import { useDraggable, UseDraggableArguments } from "@dnd-kit/core";
import React, { useEffect } from "react";

interface Props {
  id: string;
  data?: UseDraggableArguments["data"];
  setIsDragging: (val: boolean) => void;
  setActiveId: (id: string | null) => void;
  setDraggedQuote: (q: any) => void;
  quote: any;
  activeId: string | null;
  children: React.ReactNode;
}

const KanbanItem: React.FC<Props> = React.memo(
  ({
    children,
    id,
    data,
    setIsDragging,
    setActiveId,
    setDraggedQuote,
    quote,
    activeId,
  }) => {
    const { attributes, listeners, setNodeRef, active } = useDraggable({
      id,
      data,
    });

    useEffect(() => {
      if (active && active.id === id) {
        setIsDragging(true);
        setActiveId(id);
        setDraggedQuote(quote);
      } else if (!active) {
        setIsDragging(false);
        setActiveId(null);
        setDraggedQuote(null);
      }
    }, [active, id, setIsDragging, setActiveId, setDraggedQuote, quote]);

    return (
      <div
        ref={setNodeRef}
        {...attributes}
        {...listeners}
        style={{
          opacity: activeId === id ? 0.5 : 1,
          borderRadius: "8px",
          cursor: "grab",
          position: "relative",
        }}
      >
        {children}
      </div>
    );
  },
);

export default KanbanItem;
